import {api} from './api';

export const profileService={
  update: async (profile)=> (await api('/profile',{method: 'PUT',body: profile})).user,
  changePassword: (currentPassword,newPassword)=>
    api('/profile/password',{method: 'PUT',body: {currentPassword,newPassword}}),
};
